import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_spinner.scss'

import { Props, SizeNS, DivAttributes } from '../utils/types'

export type SpinnerSize =
  | typeof SizeNS.xs
  | typeof SizeNS.sm
  | typeof SizeNS.md
  | typeof SizeNS.lg

export namespace SpinnerVariantNS {
  export const none = ''
  export const light = 'light'
}

type SpinnerVariant =
  | typeof SpinnerVariantNS.none
  | typeof SpinnerVariantNS.light

export interface SpinnerProps extends Props {
  label?: string
  loading?: boolean
  size?: SpinnerSize
  variant?: SpinnerVariant
}

const cx = bind(styles)

export const Spinner = React.forwardRef<
  HTMLDivElement,
  DivAttributes & SpinnerProps
>(
  (
    {
      children,
      className = '',
      label = 'loading',
      loading = false,
      size = SizeNS.lg,
      variant = SpinnerVariantNS.none,
      ...props
    },
    ref
  ) => {
    const circle = (
      <div
        ref={ref}
        className={cx('core-spinner__circle', `core-spinner__circle--${size}`, {
          [`core-spinner__circle--${variant}`]: variant,
          [className]: !children,
        })}
      />
    )

    if (!children) {
      return circle
    }

    return (
      <div
        className={cx(
          'core-spinner',
          {
            'core-spinner--loading': loading,
          },
          className
        )}
        aria-busy={loading}
        {...props}
      >
        <div className={cx('core-spinner__overlay')} />
        <div className={cx('core-spinner__container')}>
          {circle}
          <div className={cx('core-spinner__label')}>{label}</div>
        </div>
        {children}
      </div>
    )
  }
)

Spinner.displayName = 'Spinner'

export default Spinner
